/* ChinaTourly ct3 components (claude-ct, 2026-10). Vanilla JS, no dependencies; GSAP loaded only where needed. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveal on first view */
  function observeReveals(root) {
    var els = (root || document).querySelectorAll('.ct3-reveal:not(.is-in), .ct3-ink-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { els.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) e.classList.add('is-in'); }); }, 1500);
  }

  /* ink-bleed title: per-character reveal through an SVG displacement filter */
  function ensureInkFilter() {
    if (document.getElementById('ct3-ink-filter')) return;
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('width', '0'); s.setAttribute('height', '0'); s.setAttribute('aria-hidden', 'true');
    s.style.position = 'absolute';
    s.innerHTML = '<filter id="ct3-ink-filter"><feTurbulence type="fractalNoise" baseFrequency="0.035" numOctaves="2" seed="7" result="n"/>' +
      '<feDisplacementMap in="SourceGraphic" in2="n" scale="0"><animate attributeName="scale" values="38;0" dur="0.9s" fill="freeze" begin="indefinite"/></feDisplacementMap></filter>';
    document.body.appendChild(s);
  }
  customElements.define('ct3-inkbleed', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return; this.dataset.ready = '1';
      var text = this.textContent; var label = text.replace(/\s+/g, ' ').trim();
      this.setAttribute('aria-label', label);
      if (reduce) return;
      this.textContent = '';
      var i = 0, self = this;
      text.split(/(\s+)/).forEach(function (word) {
        if (/^\s+$/.test(word)) { self.appendChild(document.createTextNode(word)); return; }
        var w = document.createElement('span'); w.style.whiteSpace = 'nowrap'; w.setAttribute('aria-hidden', 'true');
        word.split('').forEach(function (ch) {
          var c = document.createElement('span'); c.textContent = ch; c.className = 'ct3-ink-ch';
          c.style.cssText = 'display:inline-block;opacity:0;filter:blur(6px);transform:translateY(.12em);transition:opacity 700ms cubic-bezier(.23,1,.32,1),filter 900ms cubic-bezier(.23,1,.32,1),transform 700ms cubic-bezier(.23,1,.32,1);transition-delay:' + (i++ * 35) + 'ms';
          w.appendChild(c);
        });
        self.appendChild(w);
      });
      var run = function () { self.querySelectorAll('.ct3-ink-ch').forEach(function (c) { c.style.opacity = '1'; c.style.filter = 'blur(0)'; c.style.transform = 'none'; }); };
      if (!('IntersectionObserver' in window)) { run(); return; }
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { run(); io.disconnect(); } }, { threshold: 0.3 });
      io.observe(this);
    }
  });

  /* split-flap board: cycles a few characters then settles */
  customElements.define('ct3-flapboard', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return; this.dataset.ready = '1';
      var cells = this.querySelectorAll('[data-flap]');
      if (reduce || !cells.length) return;
      var CH = 'ABCDEFGHIJKLMNOPRSTUVWXYZ0123456789';
      cells.forEach(function (cell) {
        var final = cell.textContent; cell.setAttribute('aria-label', final); cell.textContent = '';
        final.split('').forEach(function (ch) { var s = document.createElement('span'); s.className = 'ct3-flap'; s.dataset.f = ch; s.textContent = ch === ' ' ? ' ' : ch; s.setAttribute('aria-hidden', 'true'); cell.appendChild(s); });
      });
      var self = this;
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        var k = 0;
        self.querySelectorAll('.ct3-flap').forEach(function (s) {
          var f = s.dataset.f; if (f === ' ') return;
          var n = 4 + Math.floor(Math.random() * 3), t = 0, start = (k++ % 26) * 20;
          setTimeout(function tick() {
            if (t++ < n) { s.textContent = CH[Math.floor(Math.random() * CH.length)]; setTimeout(tick, 60); } else { s.textContent = f; }
          }, start);
        });
      }, { threshold: 0.4 });
      io.observe(this);
    }
  });

  /* feelings / scenario selector: data in a JSON script tag */
  customElements.define('ct3-feelings', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return; this.dataset.ready = '1';
      var data; try { data = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      var out = this.querySelector('.ct3-feel__results'), self = this, chips = this.querySelectorAll('.ct3-chip');
      function render(key) {
        var list = data[key] || []; out.innerHTML = '';
        list.forEach(function (p) {
          var a = document.createElement('a'); a.className = 'ct3-card'; a.href = p.url;
          a.innerHTML = '<div class="ct3-media"><img loading="lazy" alt="" src="' + p.img + '"></div>' +
            '<div class="ct3-card__meta"><span></span><span></span></div><h3 class="ct3-card__title"></h3>';
          a.querySelector('img').alt = p.alt || p.title;
          var m = a.querySelectorAll('.ct3-card__meta span'); m[0].textContent = p.meta || ''; m[1].textContent = p.price || '';
          a.querySelector('.ct3-card__title').textContent = p.title;
          out.appendChild(a);
        });
        self.dispatchEvent(new CustomEvent('ct3:render', { bubbles: true }));
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          render(c.dataset.key);
          if (window.gtag) { try { window.gtag('event', 'select_scenario', { scenario: c.dataset.key }); } catch (e) {} }
        });
      });
      var first = this.querySelector('.ct3-chip[aria-pressed="true"]') || chips[0];
      if (first) { first.setAttribute('aria-pressed', 'true'); render(first.dataset.key); }
    }
  });

  /* handscroll: pinned horizontal panels with GSAP, desktop only */
  function loadScript(src) {
    return new Promise(function (res, rej) {
      if (document.querySelector('script[src="' + src + '"]')) { res(); return; }
      var s = document.createElement('script'); s.src = src; s.async = true; s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
  }
  /* header: mobile drawer */
  function initHeader() {
    var b = document.querySelector('[data-ct3-burger]'), d = document.querySelector('.ct3-drawer');
    if (!b || !d) return;
    function close(focus) {
      if (!d.classList.contains('is-open')) return;
      d.classList.remove('is-open'); d.inert = true; b.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = '';
      if (focus) b.focus();
    }
    b.addEventListener('click', function () {
      var open = d.classList.toggle('is-open'); d.inert = !open; b.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { var closer = d.querySelector('[data-ct3-drawer-close]'); if (closer) closer.focus(); }
    });
    var closer = d.querySelector('[data-ct3-drawer-close]');
    if (closer) closer.addEventListener('click', function () { close(true); });
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !d.classList.contains('is-open')) return;
      var items = Array.from(d.querySelectorAll('a[href],button,summary,input,select,textarea,[tabindex="0"]')).filter(function(el){return el.getClientRects().length && !el.disabled;});
      if (!items.length) return;
      var first = items[0], last = items[items.length-1];
      if(e.shiftKey && document.activeElement === first){e.preventDefault();last.focus();}
      else if(!e.shiftKey && document.activeElement === last){e.preventDefault();first.focus();}
    });
    d.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { close(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Esc') close(true); });
    var wide = window.matchMedia('(min-width: 990px)'), onWide = function (m) { if (m.matches) close(false); };
    if (wide.addEventListener) wide.addEventListener('change', onWide); else if (wide.addListener) wide.addListener(onWide);
  }

  /* sticky booking bar: visible after the hero, hidden while the real booking block is on screen */
  function initBookbar() {
    var bar = document.querySelector('.ct3-bookbar'); if (!bar) return;
    var hero = document.querySelector('[data-ct3-product-hero], #hero, .hero');
    var booking = document.querySelector('#dates, [data-ctc-booking], .ct-short__booking');
    var heroOut = false, bookingIn = false;
    function upd() { bar.classList.toggle('is-on', heroOut && !bookingIn); }
    if (!('IntersectionObserver' in window)) return;
    if (hero) new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; upd(); }).observe(hero);
    if (booking) new IntersectionObserver(function (e) { bookingIn = e[0].isIntersecting; upd(); }, { threshold: 0.05 }).observe(booking);
    document.body.classList.add('ct3-has-bookbar');
  }

  /* lazy-load heavy legacy map sections only when close to the viewport */
  function initLazyLegacy() {
    document.querySelectorAll('template[data-ct3-lazy]').forEach(function (tpl) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        var holder = tpl.parentNode; holder.appendChild(tpl.content.cloneNode(true));
        holder.querySelectorAll('script').forEach(function (old) { var s = document.createElement('script'); if (old.src) s.src = old.src; else s.textContent = old.textContent; old.replaceWith(s); });
      }, { rootMargin: '300px 0px' });
      io.observe(tpl.parentNode);
    });
  }


  /* move ct3 extras into position inside legacy product layout */
  function placeExtras() {
    document.querySelectorAll('[data-ct3-insert-before]').forEach(function (el) {
      var target = document.querySelector(el.getAttribute('data-ct3-insert-before'));
      if (target && target.parentNode) target.parentNode.insertBefore(el, target);
    });
    var bar = document.querySelector('.ct3-bookbar');
    if (bar && !document.querySelector('#dates')) { var b = bar.querySelector('a[href="#dates"]'); var alt = document.querySelector('[data-ctc-booking], .ctc-booking, [id*="book"]'); if (b && alt) { if (!alt.id) alt.id = 'ct3-book'; b.setAttribute('href', '#' + alt.id); } }
  }

  /* bespoke builder: 4-phase progress over the existing 7 steps, and no "$0" estimate */
  function initBuilder() {
    var area = document.getElementById('stepArea'); if (!area) return;
    var phases = ['Who is travelling', 'Length and pace', 'What you love', 'Where, and your draft'];
    var map = { 1: 0, 2: 0, 3: 1, 4: 1, 5: 2, 6: 3, 7: 3 };
    var ul = document.createElement('ol'); ul.className = 'ct3-phases'; ul.setAttribute('aria-label', 'Progress');
    phases.forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
    var rail = document.querySelector('.step-rail-wrap');
    if (rail) { rail.classList.add('ct3-rail-replaced'); rail.appendChild(ul); }
    else { ul.style.gridColumn = '1 / -1'; area.parentNode.insertBefore(ul, area); }
    function sync() {
      var eb = area.querySelector('.step-eyebrow'); var m = eb && eb.textContent.match(/Step\s+(\d+)/i);
      var cur = m ? map[+m[1]] : 0;
      ul.querySelectorAll('li').forEach(function (li, i) { li.className = i < cur ? 'is-done' : (i === cur ? 'is-current' : ''); if (i === cur) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current'); });
      document.querySelectorAll('body *').forEach(function (el) {
        if (el.children.length === 0 && el.textContent.trim() === '$0') { el.textContent = 'Choose cities to see an estimate'; el.style.fontSize = '18px'; }
      });
    }
    document.querySelectorAll('p, span, div').forEach(function (el) {
      if (el.children.length) return; var t = el.textContent.trim();
      if (/^Move your cursor across this page/i.test(t)) el.textContent = 'Four short steps build a real draft itinerary with a price estimate. It goes straight to the planner who will design your trip.';
      else if (/MOVE CURSOR/i.test(t) && /TRAIL/i.test(t)) el.style.display = 'none';
    });
    sync(); new MutationObserver(sync).observe(area, { childList: true, subtree: true });
  }


  /* day finder: slider filters real journeys by duration, FLIP re-flow */
  customElements.define('ct3-dayfinder', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return; this.dataset.ready = '1';
      var range = this.querySelector('[data-range]'), out = this.querySelector('[data-days]'), items = Array.prototype.slice.call(this.querySelectorAll('[data-d]')), empty = this.querySelector('[data-empty]');
      if (!range) return;
      var max = +range.max;
      function apply(animate) {
        var v = +range.value; out.textContent = v >= max ? max + '+' : v;
        range.style.setProperty('--p', ((v - range.min) / (range.max - range.min) * 100) + '%');
        var first = new Map(); if (animate && !reduce) items.forEach(function (it) { if (!it.hidden) first.set(it, it.getBoundingClientRect()); });
        var pick = items.filter(function (it) { var d = +it.dataset.d; return v >= max ? d >= max - 2 : Math.abs(d - v) <= 2; })
          .sort(function (a, b) { return Math.abs(+a.dataset.d - v) - Math.abs(+b.dataset.d - v); }).slice(0, 4);
        var shown = pick.length;
        items.forEach(function (it) { it.hidden = pick.indexOf(it) < 0; });
        empty.hidden = shown > 0;
        if (!animate || reduce) return;
        items.forEach(function (it) {
          if (it.hidden) return; var r = it.getBoundingClientRect(), f = first.get(it);
          if (f) { var dx = f.left - r.left, dy = f.top - r.top; if (dx || dy) it.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 520, easing: 'cubic-bezier(.23,1,.32,1)' }); }
          else it.animate([{ opacity: 0, transform: 'translateY(18px) scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: 480, easing: 'cubic-bezier(.23,1,.32,1)' });
        });
      }
      var t; range.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { apply(true); }, 40); });
      range.addEventListener('change', function () { if (window.gtag) { try { window.gtag('event', 'select_days', { days: +range.value }); } catch (e) {} } });
      apply(false);
    }
  });

  /* rails: mouse drag with momentum (touch keeps native scrolling) */
  function initRails(root) {
    (root || document).querySelectorAll('.ct3-rail:not([data-drag])').forEach(function (r) {
      r.setAttribute('data-drag', '1');
      var down = false, sx = 0, sl = 0, moved = 0, v = 0, lx = 0, raf;
      r.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = 0; sx = lx = e.clientX; sl = r.scrollLeft; v = 0; cancelAnimationFrame(raf); r.classList.add('is-drag'); });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx)); v = e.clientX - lx; lx = e.clientX; r.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; r.classList.remove('is-drag');
        (function glide() { v *= 0.93; r.scrollLeft -= v; if (Math.abs(v) > 0.5) raf = requestAnimationFrame(glide); })(); });
      r.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      r.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* motion layer (GSAP + ScrollTrigger + SplitText + Lenis), loaded after first paint */
  function loadMotion() {
    var me = document.querySelector('script[src*="ct3-core.js"]'); if (!me) return;
    var src = me.src.split('?')[0].replace('ct3-core.js', 'ct3-motion.js') + '?v=f20a3871e8';
    var go = function () { var s = document.createElement('script'); s.src = src; s.async = true; document.head.appendChild(s); };
    go();
  }

  function boot() { placeExtras(); observeReveals(); initHeader(); initBookbar(); initRails(); loadMotion(); initLazyLegacy(); initBuilder(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { observeReveals(e.target); initRails(e.target); });
})();
